<template>
  <form @submit.prevent="onSave">
    <modal-card title="Create serving" contains-dropdown>
      <div class="columns" v-if="optionType()">
        <div class="column is-6">
          <b-field label="Select type">
            <b-select placeholder="Select a type" v-model="form.option_type" expanded>
              <option value="all">All</option>
            <option value="magazine-category">Category</option>
            <option value="magazine-issue">Issue</option>
            <option value="magazine">Magazine</option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field :label="'Select ' + form.option_type" v-if="form.option_type == 'magazine'">
            <magazine-selector v-model="form.option_id"></magazine-selector>
          </b-field>

          <b-field
            :label="'Select ' + form.option_type"
            v-if="form.option_type == 'magazine-category'"
          >
            <category-selector v-model="form.option_id"></category-selector>
          </b-field>

          <b-field
            :label="'Select ' + form.option_type"
            v-if="form.option_type == 'magazine-issue'"
          >
            <issue-select v-model="form.option_id"></issue-select>
          </b-field>
        </div>
      </div>

      <div v-else class="columns">
        <div class="column is-6">
          <b-field label="Select type">
            <b-select placeholder="Select a type" v-model="form.option_type" expanded>
              <option value="all">All</option>
              <option value="magazine-category">Category </option>
              <option value="magazine-issue">Issue</option>
              <option value="magazine">Magazine</option>
            </b-select>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <b-field label="Start Date">
            <datetimepicker
              placeholder="Type or select a date..."
              icon="calendar-today"
              v-model="form.start_date"
              editable
            ></datetimepicker>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="End Date">
            <datetimepicker
              placeholder="Type or select a date..."
              icon="calendar-today"
              v-model="form.end_date"
              :min-datetime="form.start_date"
              editable
            ></datetimepicker>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <b-field label="Select strategy">
            <b-select placeholder="Select a strategy" v-model="form.page_number_strategy" expanded>
              <option value="fixed">Fixed</option>
              <option value="start_from_current_page">Start from current page</option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Page number">
            <b-input v-model="form.page_number" placeholder="Page number"></b-input>
          </b-field>
        </div>
      </div>

      <p
        class="is-marginless"
        v-if="form.page_number &&  form.page_number_strategy == 'fixed'"
      >Ads will display on the {{ form.page_number }}th page.</p>

      <p
        class="is-marginless"
        v-else-if="form.page_number && form.page_number_strategy == 'start_from_current_page'"
      >Ads will display on the +{{ form.page_number }}th page.</p>

      <p v-else>Please insert the page number the ads will be display on.</p>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">Cancel</button>
        <button class="button is-primary" :class="{'is-loading': form.processing}">Save</button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import MagazineSelector from "./../../../components/selectors/MagazineSelector";
import CategorySelector from "./../../../components/selectors/CategorySelector";
import IssueSelect from "./../../../components/selectors/IssueSelect";

export default {
  components: {
    MagazineSelector,
    CategorySelector,
    IssueSelect
  },

  data() {
    return {
      form: new window.Form({
        page_id: this.adsContent.id,
        option_type: null,
        option_id: null,
        start_date: null,
        end_date: null,
        page_number: null,
        page_number_strategy: "fixed"
      })
    };
  },
  props: {
    adsContent: {
      type: Object,
      required: true
    },

    whenUpdated: {
      type: Function,
      default: () => () => {}
    }
  },

  methods: {
    onSave() {
      this.form.post(`/admin/api/servings`).then(this.whenSaved);
    },

    whenSaved() {
      this.$buefy.toast.open("Servings successfully created.");

      this.$parent.close();

      this.whenUpdated(this.form);
    },

    optionType() {
      if (this.form.option_type == null || this.form.option_type == "all") {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
